import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import RefreshIndicator from 'material-ui/RefreshIndicator';

const Preloader = function Preloader(props) {
  const {
    loading,
    blocking,
  } = props;
  if (loading > 0) {
    let blockingCls = '';
    if (blocking === true) {
      blockingCls = 'blocking';
    }
    return (
      <div className={`Preloader ${blockingCls}`}>
        <div className="indicator-container">
          <RefreshIndicator
            size={50}
            left={0}
            top={0}
            status={'loading'}
          />
        </div>
      </div>
    );
  }
  return (
    <div />
  );
};

Preloader.propTypes = {
  loading: PropTypes.number,
  blocking: PropTypes.bool,
};

Preloader.defaultProps = {
  loading: 0,
  blocking: false,
};

const mapStateToProps = state => ({
  loading: state.loadingBar.loading,
  blocking: state.loadingBar.blocking,
});

export default connect(mapStateToProps)(Preloader);



// WEBPACK FOOTER //
// ./src/containers/Preloader.js